class Currency {
  static toDe(
    value: number | undefined,
    {
      withSymbol = true,
      locale = 'de',
      withDigits = false,
    }: {
      withSymbol?: boolean;
      locale?: string;
      withDigits?: boolean;
    } = {}
  ) {
    let rv = 'n/a';
    if (value === -1) {
      // use default in this case
    } else if (typeof value === 'number') {
      const n = withDigits ? value / 100 : Math.ceil(value / 100);
      const s = withDigits
        ? n.toLocaleString(locale, { minimumFractionDigits: 2 })
        : n.toLocaleString(locale);

      rv = withSymbol ? `${s}€` : `${s}`;
    }
    return rv;
  }
}

export { Currency };
